import { css } from 'twind/css'

export const requestMicrophoneAccessCTAContainerV2 = css`
  button {
    color: var(--blk2);
  }

  button:nth-child(2) {
    border: none;
    font-weight: 400;
  }
`
